import {HttpOperacionInforme} from "../../../api/httpOperacionInforme";
import {SistemaTipo} from "../../../../../types/enum/enum";


export const descargarInforme = (
  idOperacion: number
): Promise<any> => {
  return HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.MinutaCredito);
}
